import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { fundingPresets } from '../amount/funding-presets.js';
import { withdrawalAmount, withdrawalFeeEstimate } from './amount.js';
export function useWithdrawalAmount(client, method, surface, currency, input, balanceD6, active, limits) {
  const amount = withdrawalAmount(input, balanceD6, currency, Date.now(), method === 'manual_withdraw' ? undefined : limits, method !== null && method !== 'manual_withdraw');
  const [settled, setSettled] = useState(null);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(amount.amountD6), 400);
    return () => clearTimeout(timer);
  }, [amount.amountD6]);
  const enabled = active && method !== null && method !== 'manual_withdraw' && amount.amountD6 !== null && !amount.boundary && settled === amount.amountD6;
  const quote = useQuery({
    queryKey: ['onramp', client.cacheKey, 'withdrawal-preview', method, surface, currency.currency, amount.amountD6],
    enabled,
    queryFn: ({
      signal
    }) => {
      if (!method || method === 'manual_withdraw' || !amount.amountD6) throw new Error('offramp_invalid_quote');
      return client.quoteWithdrawal({
        method,
        amountD6: amount.amountD6,
        currency: currency.currency,
        surface
      }, signal);
    },
    retry: false,
    staleTime: 15000,
    meta: {
      persist: false
    }
  });
  const estimate = withdrawalFeeEstimate(active && !amount.boundary ? quote.data : null, amount.amountD6, input, currency.currency, currency.decimals);
  const presets = fundingPresets(currency.currency, currency.decimals, currency.fx, Date.now(), {
    ...(amount.maximumUnits === null ? {} : {
      maximumUnits: amount.maximumUnits
    }),
    ...(amount.minimumUnits === null ? {} : {
      minimumUnits: amount.minimumUnits
    })
  });
  return {
    ...amount,
    quote,
    estimate,
    presets: [...new Set([...presets.slice(0, 3), ...(amount.maximumUnits && BigInt(amount.maximumUnits) > 0n && (!amount.minimumUnits || BigInt(amount.maximumUnits) >= BigInt(amount.minimumUnits)) ? [amount.maximumUnits] : [])])],
    loading: active && method !== 'manual_withdraw' && Boolean(amount.amountD6) && !amount.boundary && (settled !== amount.amountD6 || quote.isFetching)
  };
}